import script from "./WorkflowAprovacaoGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAprovacaoGrid.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAprovacaoGrid.vue?vue&type=style&index=0&id=358dcdc8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-358dcdc8"]])

export default __exports__